"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyEvent = exports.LpKeyEventDirection = void 0;
const react_1 = require("react");
var LpKeyEventDirection;
(function (LpKeyEventDirection) {
    LpKeyEventDirection["Up"] = "keyup";
    LpKeyEventDirection["Down"] = "keydown";
})(LpKeyEventDirection = exports.LpKeyEventDirection || (exports.LpKeyEventDirection = {}));
const useKeyEvent = (direction, handler, options = {}) => {
    const { enabled = true, targetKeys, preventDefault = true } = options;
    (0, react_1.useEffect)(() => {
        const onKey = (event) => {
            if (enabled && (!targetKeys || targetKeys.includes(event.key))) {
                if (preventDefault) {
                    event.preventDefault();
                }
                handler(event, event.key);
            }
        };
        window.addEventListener(direction, onKey);
        return () => {
            window.removeEventListener(direction, onKey);
        };
    }, [enabled, targetKeys, preventDefault, handler]);
};
exports.useKeyEvent = useKeyEvent;
